var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',{staticClass:"content"},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin content-loading"}):_vm._e(),(!_vm.loading)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }